import React, { createContext } from "react";
import * as SurveySplashData from "../utils/survey-splash-data";

export const SurveySplashDataContext = createContext();

const SurveySplashDataProvider = ({ data, children }) => {
  const { surveyMetadata, welcomeData, generalInfoData } = SurveySplashData.destructureData(data);

  return (
    <SurveySplashDataContext.Provider value={{ welcomeData, generalInfoData, surveyMetadata }}>
      {children}
    </SurveySplashDataContext.Provider>
  );
};

export default SurveySplashDataProvider;
